/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient()
